var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.loading } },
            [_c("ListFilter")],
            1
          ),
          _vm._l(_vm.emails, function(item) {
            return _c("ListRow", { key: item.id, attrs: { item: item.source } })
          }),
          _c(
            "b-overlay",
            { attrs: { show: _vm.loading } },
            [_c("ListPagination")],
            1
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }